import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Leaderboards from "@/pages/Leaderboards";
import Results from "@/pages/Results";
import WhereToPlay from "@/pages/WhereToPlay";
import Gallery from "@/pages/Gallery";
import SeasonArchive from "@/pages/SeasonArchive";
import PlayerProfile from "@/pages/PlayerProfile";
import HallOfChampions from "@/pages/HallOfChampions";
import ScrollToTop from "@/components/ScrollToTop";
import About from "@/pages/About";
import BecomeLegend from "@/pages/BecomeLegend";
import BecomeHost from "@/pages/BecomeHost";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import InfoPage from "@/pages/InfoPage";
import SetPassword from "@/pages/SetPassword";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import RulesPage from "@/pages/RulesPage";
import MemberCharter from "@/pages/MemberCharter";
import PointsPayouts from "@/pages/PointsPayouts";
import { infoPages } from "@/pages/infoContent";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/events" element={<Layout><Events /></Layout>} />
      <Route path="/events/:id" element={<Layout><EventDetail /></Layout>} />
      <Route path="/leaderboards" element={<Layout><Leaderboards /></Layout>} />
      <Route path="/results" element={<Layout><Results /></Layout>} />
      <Route path="/where-to-play" element={<Layout><WhereToPlay /></Layout>} />
      <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
      <Route path="/seasons" element={<Layout><SeasonArchive /></Layout>} />
      <Route path="/players/:name" element={<Layout><PlayerProfile /></Layout>} />
      <Route path="/hall-of-legends" element={<Layout><HallOfChampions /></Layout>} />
      <Route path="/hall-of-champions" element={<Navigate to="/hall-of-legends" replace />} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/become-a-legend" element={<Layout><BecomeLegend /></Layout>} />
      <Route path="/become-host" element={<Layout><BecomeHost /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="/privacy" element={<Layout><PrivacyPolicy /></Layout>} />
      <Route path="/rules" element={<Layout><RulesPage /></Layout>} />
      <Route path="/member-charter" element={<Layout><MemberCharter /></Layout>} />
      <Route path="/points-payouts" element={<Layout><PointsPayouts /></Layout>} />
      {Object.keys(infoPages).map((slug) => (
        <Route key={slug} path={`/${slug}`} element={<Layout><InfoPage slug={slug} /></Layout>} />
      ))}
      <Route path="/login" element={<Login />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Layout><AdminDashboard /></Layout></ProtectedRoute>} />
      <Route path="*" element={<Layout><Home /></Layout>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppRouter />
          <Toaster position="top-right" theme="dark" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
